(function () {
  function initCountdown() {
    document.querySelectorAll('[data-fishlove-countdown]').forEach((el) => {
      const end = new Date(el.dataset.fishloveCountdown).getTime();
      if (Number.isNaN(end)) return;

      const daysEl = el.querySelector('[data-unit="days"]');
      const hoursEl = el.querySelector('[data-unit="hours"]');
      const minsEl = el.querySelector('[data-unit="minutes"]');
      const secsEl = el.querySelector('[data-unit="seconds"]');

      function tick() {
        const diff = Math.max(0, end - Date.now());
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        if (daysEl) daysEl.textContent = String(days);
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function initGallery() {
    document.querySelectorAll('.fishlove-lp-product').forEach((section) => {
      const mainImg = section.querySelector('[data-main-image]');
      const thumbs = section.querySelectorAll('[data-thumb]');
      if (!mainImg || !thumbs.length) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.fullSrc || thumb.querySelector('img')?.src;
          if (src) mainImg.src = src;
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initBundles() {
    document.querySelectorAll('.fishlove-lp-product').forEach((section) => {
      const form = section.querySelector('form[action*="/cart/add"]');
      const qtyInput = form?.querySelector('[name="quantity"]');
      const bundles = section.querySelectorAll('[data-bundle-qty]');
      const priceEl = section.querySelector('[data-live-price]');
      if (!form || !qtyInput || !bundles.length) return;

      bundles.forEach((bundle) => {
        bundle.addEventListener('click', () => {
          const qty = parseInt(bundle.dataset.bundleQty, 10) || 1;
          const price = bundle.dataset.bundlePrice;
          qtyInput.value = qty;
          bundles.forEach((b) => b.classList.remove('is-selected'));
          bundle.classList.add('is-selected');
          if (priceEl && price) priceEl.textContent = price;
        });
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('button.fishlove-lp-faq__question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.fishlove-lp-faq__item');
        const wasOpen = item.classList.contains('is-open');
        item.closest('.fishlove-lp-faq__list')
          ?.querySelectorAll('.fishlove-lp-faq__item')
          .forEach((i) => i.classList.remove('is-open'));
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  function initReviewsCarousel() {
    document.querySelectorAll('[data-fishlove-reviews-carousel]').forEach((root) => {
      const track = root.querySelector('[data-carousel-track]');
      const slides = track ? Array.from(track.querySelectorAll('[data-carousel-slide]')) : [];
      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      const dotsWrap = root.querySelector('[data-carousel-dots]');
      if (!track || !slides.length) return;

      let active = 0;
      let autoplayTimer;

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fishlove-reviews-carousel__dot';
          dot.setAttribute('aria-label', `Go to review ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dotsWrap.appendChild(dot);
        });
      }

      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.fishlove-reviews-carousel__dot')) : [];

      function updateButtons() {
        if (prev instanceof HTMLButtonElement) prev.disabled = active <= 0;
        if (next instanceof HTMLButtonElement) next.disabled = active >= slides.length - 1;
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      }

      function goTo(index) {
        active = Math.max(0, Math.min(index, slides.length - 1));
        const slide = slides[active];
        if (slide) {
          track.scrollTo({
            left: slide.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        }
        updateButtons();
      }

      function onScroll() {
        const center = track.scrollLeft + track.clientWidth / 2;
        let closest = 0;
        let minDist = Infinity;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
          const dist = Math.abs(center - slideCenter);
          if (dist < minDist) {
            minDist = dist;
            closest = index;
          }
        });
        active = closest;
        updateButtons();
      }

      prev?.addEventListener('click', () => goTo(active - 1));
      next?.addEventListener('click', () => goTo(active + 1));
      track.addEventListener('scroll', onScroll, { passive: true });

      const startAutoplay = () => {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(() => {
          goTo(active >= slides.length - 1 ? 0 : active + 1);
        }, 5000);
      };

      root.addEventListener('mouseenter', () => clearInterval(autoplayTimer));
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', () => clearInterval(autoplayTimer));
      root.addEventListener('focusout', startAutoplay);

      updateButtons();
      startAutoplay();
    });
  }

  function init() {
    initCountdown();
    initGallery();
    initBundles();
    initFaq();
    initReviewsCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
